export interface DocumentPageTarget {
  minPages: number;
  maxPages: number;
  estimatedWords: number;
  estimatedChars: number;
}

const WORDS_PER_PAGE = 400;
const CHARS_PER_WORD = 5.5;

function createTarget(minPages: number, maxPages: number): DocumentPageTarget {
  const avgPages = (minPages + maxPages) / 2;
  const estimatedWords = Math.round(avgPages * WORDS_PER_PAGE);
  const estimatedChars = Math.round(estimatedWords * CHARS_PER_WORD);
  return { minPages, maxPages, estimatedWords, estimatedChars };
}

export const documentPageTargets: Record<string, DocumentPageTarget> = {
  'standard-residential': createTarget(35, 45),
  'periodic-tenancy': createTarget(35, 45),
  'tenancy-conversion-pack': createTarget(20, 25),
  'commercial-lease': createTarget(30, 40),
  'deposit-protection': createTarget(8, 12),
  'section8-ground8': createTarget(12, 15),
  'section8-ground14': createTarget(12, 15),
  'mediation-agreement': createTarget(15, 20),
  'rent-increase': createTarget(8, 10),
  'inventory-report': createTarget(25, 35),
  'witness-statement': createTarget(10, 15),
  'possession-claim': createTarget(15, 20),
  'student-accommodation': createTarget(20, 30),
  'property-inspection': createTarget(20, 30),
  'right-to-rent': createTarget(6, 8),
  'dispute-framework': createTarget(15, 20),
  'mediation-request': createTarget(8, 12),
  'evidence-collection': createTarget(10, 15),
  'communication-log': createTarget(6, 10),
  'settlement-agreement': createTarget(15, 20),
  'mediation-guide': createTarget(12, 15),
  'dispute-assessment': createTarget(10, 15),
  'rent-arrears-schedule': createTarget(8, 12),
  'section8-assessment': createTarget(12, 18),
  'pre-action-protocol': createTarget(10, 15),
  'court-bundle': createTarget(15, 20),
  'written-statement-prescribed-terms': createTarget(6, 10),
  'section-13-notice': createTarget(3, 5),
};

const DEFAULT_TARGET = createTarget(15, 20);

export function getPageTarget(documentType: string): DocumentPageTarget {
  return documentPageTargets[documentType] || DEFAULT_TARGET;
}

export function getEstimatedTotalChars(documentType: string): number {
  return getPageTarget(documentType).estimatedChars;
}

const TOKENS_PER_PART = 5000;
const TOKENS_PER_WORD = 1.4;

export function getEstimatedParts(documentType: string): number {
  const target = getPageTarget(documentType);
  const estimatedTokens = Math.round(target.estimatedWords * TOKENS_PER_WORD);
  return Math.max(1, Math.ceil(estimatedTokens / TOKENS_PER_PART));
}

export function needsMultiPart(documentType: string): boolean {
  return getEstimatedParts(documentType) > 1;
}

export function getMaxTokensPerPart(): number {
  return TOKENS_PER_PART;
}
